import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import cn from 'classnames';
import Stats from 'frontend_stats';
import { HeapUtil } from 'core/utils';
import ApiRequest from 'core/api/request';

import { captureMessage } from 'error_tracker';
import { parseError } from 'core/api/utils';
import { Wrapper, StableHeart, FloatHeart } from './styles';
import { getListingProps } from 'core/utils/Braze';
import { trackEvent, promiser, identify } from 'core/utils';

class FavoriteHeart extends PureComponent {
	state = {
		poof: false,
		pressed: false,
		favorited: this.props.favorited,
	}

	triggerLogin = () => {
		// Unfortunately we can't put the `LoginModalHoc` in here
		// bc of weird positioning it doesnt go fullscreen as it should
		Stats.trackGeneric("login_prompt", { step_name: "favorite" });
		window.cj.loginModal && window.cj.loginModal.triggerLoginModal(null, "favorite-heart");
		return;
	}

	handleFavorite = async e => {
		e && e.stopPropagation();
		const { listingId } = this.props;

		const favorited = !this.state.favorited;
		this.setState({ poof: favorited, favorited: favorited });

		const [error, res] = await promiser(ApiRequest.post("/wishlistings/", { listingId, method: "box" }));

		if (error) {
			// report error & revert state:
			const msg = parseError(error);
			captureMessage(`Favorite failed: ${msg}`);
			this.setState({ favorited: !favorited });
			return;
		}

		HeapUtil.track("wishlistInteraction", { action: favorited ? "added" : "removed" });

		if (favorited) {
			const listing = { listingId: listingId };
			trackEvent("listing_box_fav", {
				braze: [getListingProps(listing)],
				statjoy: [{ cus1: listingId }]
			});
		}

		identify({ force: true });
	}

	handleMouseEvt = e => {
		this.setState({ pressed: e.type === "mousedown" });
	}

	render() {
		const { handleMouseEvt, handleFavorite, triggerLogin } = this;
		const { isLoggedIn } = this.props;
		const { poof, pressed, favorited } = this.state;
		const wrapperProps = {
			className: cn({ poof, pressed, favorited }),
			onMouseDown: handleMouseEvt,
			onMouseUp: handleMouseEvt,
			onClick: isLoggedIn ? handleFavorite : triggerLogin,
		};
		return (
			<Wrapper {...wrapperProps}>
				<StableHeart />
				<FloatHeart />
			</Wrapper>
		);
	}
}

FavoriteHeart.propTypes = {
	listingId: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number,
	]).isRequired,
	favorited: PropTypes.bool,
	isLoggedIn: PropTypes.bool,
};

export default FavoriteHeart;
